import { useMemo } from 'react';

import { IFilterValues } from '../models';

export const useFiltersData = (values: IFilterValues) => {
	const filtersData = useMemo(() => {
		if (!values)
			return {
				loanId: undefined,
				maxInterestRate: undefined,
				minInterestRate: undefined,
				minAmount: undefined,
				maxAmount: undefined,
				originatorTitle: undefined,
				projectTitle: undefined,
				type: undefined,
				companyName: undefined,
				isPurchased: undefined,
			} as any;

		const {
			'interestRate[from]': removedFrom,
			'interestRate[to]': removedTo,
			'investedAmount[from]': removedAmountFrom,
			'investedAmount[to]': removedAmountTo,
			'sellingPrice[from]': removedSellingPriceFrom,
			'sellingPrice[to]': removedSellingPriceTo,
			...rest
		} = values;

		return {
			...rest,
			minInterestRate: values['interestRate[from]'] || undefined,
			maxInterestRate: values['interestRate[to]'] || undefined,
			minAmount: values['investedAmount[from]'] || undefined,
			maxAmount: values['investedAmount[to]'] || undefined,
			minSellingPrice: values['sellingPrice[from]'] || undefined,
			maxSellingPrice: values['sellingPrice[to]'] || undefined,
		};
	}, [values]);

	return { filtersData };
};
